import * as React from "react";
import { Label } from "../../../../components/ui/label";
import { Controller } from "react-hook-form";
import { Checkbox } from "../../../../components/ui/checkbox";
import { MultiSelect } from "./MultiSelect.jsx";
import { useWatch } from "react-hook-form";
import { useEffect } from "react";
import {
  ViewContext,
} from 'components/lib';

const OPERATION_TYPES = [
  { value: "local_trucker",            label: "Local trucker" },
  { value: "intermediate",             label: "Intermediate" },
  { value: "long_haul_trucker",        label: "Long haul trucker" },
  { value: "intermodal_or_port",       label: "Intermodal or port" },
  { value: "household_goods_mover",    label: "Household goods mover" },
  { value: "tankers",                  label: "Tankers" },
  { value: "uiia_intermodal",          label: "UIIA - Intermodal" },
  { value: "end_dumper_units",         label: "End dumper units" },
  { value: "automobile_hauler",        label: "Automobile hauler [Excluded for cargo and NTL]" },
  { value: "refrigerated_trailer",     label: "Refrigerated Trailer" },
  { value: "oversized_or_overweight",  label: "Oversized or overweight" },
  { value: "logging",                  label: "Logging" },
  { value: "hot_shot",                 label: "Hot shot (TGL and NTL not available for class 3 vehicles)" },
  { value: "dump_truck",               label: "Dump Trucks (Other)" },
  { value: "dump_truck_sand_gravel",   label: "Dump Trucks (Dirt, Sand and Gravel)" },
] 

export const OperationSelector = ({ control, methods, watch }) => {
  const context = React.useContext(ViewContext);
  const carrier = useWatch({ control, name: "step1.carrier" });
  const noneOfMentioned = useWatch({ control, name: "step3.noneOfMentioned" });

  useEffect(() => {
    if (noneOfMentioned === true && carrier?.includes('Cover Whale')) {
      context.notification.show(
        'You are not eligible for a quote with Cover Whale.',
        'error',
        true,
        'toast',
        'x-circle'
      );
    }
  }, [noneOfMentioned]);
  return (
    <div className="space-y-2">
      <Label>Best description of your operation</Label>
      <p className="text-xs text-gray-500">Choose any that apply:</p>

      <MultiSelect
        control={control}
        name="step3.business_description"
        step={"step3"}
        disabled={watch("step3.noneOfMentioned")}
        options={OPERATION_TYPES}
      />
      <div className="flex items-center justify-between pt-2">
        <Label
          htmlFor="none-mentioned"
          className="cursor-pointer flex items-center gap-2"
        >
          <Controller
            control={control}
            name="step3.noneOfMentioned"
            render={({ field: nm }) => (
              <Checkbox
                id="none-mentioned"
                checked={!!nm.value}
                onCheckedChange={(v) => {
                  nm.onChange(v);
                  if (v) {
                    // clear selections when turning ON
                    methods.setValue("step3.business_description", [], { shouldDirty: true });
                  }
                }}
              />
            )}
          />
          None of the mentioned
        </Label>
      </div>
    </div>
  );
};
